"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.loggerWrapper = void 0;
class LoggerWrapper {
    setBackingLogger(backingLogger) {
        this.backingLogger = backingLogger;
    }
    debug(message) {
        // Silently/gracefully fail if we were never supplied with a backing logger
        if (!this.backingLogger)
            return;
        this.backingLogger.debug(message);
    }
    warn(message) {
        // Silently/gracefully fail if we were never supplied with a backing logger
        if (!this.backingLogger)
            return;
        this.backingLogger.warn(message);
    }
    info(message) {
        // Silently/gracefully fail if we were never supplied with a backing logger
        if (!this.backingLogger)
            return;
        this.backingLogger.info(message);
    }
    error(message) {
        // Silently/gracefully fail if we were never supplied with a backing logger
        if (!this.backingLogger)
            return;
        this.backingLogger.error(message);
    }
}
// Easier for consumers if we keep a concrete instance in memory and export it,
// so `setBackingLogger` can be called in a single place
exports.loggerWrapper = new LoggerWrapper();
//# sourceMappingURL=logger.js.map